// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/faq 1.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Page: About us */

.link {
    text-decoration: none; 
    color:black; 
    font-size: 12px; 
  }
  #aboutus {
    background-color: #e6ffe6;
    height: auto;
    margin: 0;
    padding: 3rem;
    border-radius: 20px;
  }
  
  #aboutus h1 {
  text-align: center;
  margin-bottom: 0.5rem;
  color: #e8c140;
  font-size: 2.5rem;
  }
  
  #aboutus p {
    font-size: 1rem;
    line-height: 2;
  }
  #aboutus span{
    font-weight: bold;
  }
  #aboutus a{
    text-decoration: none;
    color: #e3bd40;
  }
  
  #faq {
    position: relative;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    height: auto;
    padding: 4rem;
    display: flex;
    justify-content: flex-end;
    align-items: center;

  }
  
  #faq .content {
    background-color: #004d00;
    padding: 1rem;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    width: 40%;

  }
  
  #faq .content h2 {
    font-size: 1.5rem;
    margin-bottom: 0.8rem;
    color: #fff;
  }
  
  #faq .content h3 {
    font-size: 0.9rem;
    line-height: 2;
    color: #fff;
  }
  
  #faq .content p {
    font-size: 0.8rem;
    line-height: 1.5;
    color: #fff;
  }
  
  #faq .contact {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    gap: 10px;
    white-space: nowrap;
    width: auto;
    margin-top: 2rem;
    padding: 10px;
  }
  .item {
    border-bottom: 1px solid #ffffffa2;
    padding-top: 10px;
    padding-bottom: 5px;
  }
  .item + .item {
    margin-top: 10px;
  }
  #faq .content span {
    font-size: 0.7rem;
    line-height: 2;
    color: #fff;
    align-content: center;
  }
  
  .faq-question {
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    font-size: 1.2rem;
    transition: 0.4s;
  }
  .faq-answer {
    /* display: none; */
    padding-bottom: 10px;
    margin-top: 5px;
    margin-top: 5px;
  }
  i {
    color: #fff;
  }
  #ourpartners {
    text-align: center;
  }
  
  .partners {
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: 3rem;
  }
  
  .partners img {
    width: 150px;
    height: 100px;
  }
  .contact .btn-yellow:hover {
    background-color: #fff;
  }
  /* 태블릿: max-width 1024px */
  @media (max-width: 1024px) {
  #aboutus {
    padding: 2rem;
  }
  #faq {
    padding: 2rem;
    justify-content: center;
  }

  #faq .content {
    width: 70%;
  }
  .partners{
    gap:1.5rem;
    white-space: normal;
  }
}



@media  (min-width: 800px) and (max-width: 1024px) {
  .partners{
    gap: 2rem;
    white-space: normal;
  }
  .partners img{
    width: 120px;
    height: 100px;
  }

}

/* 모바일: max-width 768px */
@media (max-width: 768px) {
    /*responsiveness of about page*/
  #aboutus {
    padding: 2rem;
  }
  #faq {
    padding: 2rem;
  }
  #faq .content {
    width: 70%;
  }
  .partners{
    gap:1.5rem;
  }
  #faq .contact {
    flex-direction: row;
  }
}
/* 작은 모바일: max-width 480px */
@media (max-width: 480px) {
        /*responsiveness of about page*/
        #aboutus {
            padding: 2rem;
            height: auto;
          }
          #aboutus h1 {
            font-size: 1.5rem;
            padding-bottom: 1rem;
          }
          #aboutus p {
            font-size: 0.9rem;
            line-height: 1.8;
            text-align: justify;
          }
          #faq {
            padding: 2rem;
            margin:1rem
          }
          #faq .content {
            width: 95%;
            right: 5%;
          }
          #faq .content h2{
            font-size: 1rem;
          }
          #faq .content h3{
            font-size: 0.9rem;
          }
          #faq .content p{
            font-size: 0.8rem;
          }
          .item{
            height: auto;
          }
          .partners{
            gap:0.5rem;
          }
          .partners img{
            width:100px;
            height:auto;
          }
          #faq .contact {
          flex-direction: row;
          gap:3px;
          padding:5px;
          z-index: 1000;
          }
          #faq .contact span{
            font-size: 0.7rem;
          }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/about.css"],"names":[],"mappings":"AAAA,mBAAmB;;AAEnB;IACI,qBAAqB;IACrB,WAAW;IACX,eAAe;EACjB;EACA;IACE,yBAAyB;IACzB,YAAY;IACZ,SAAS;IACT,aAAa;IACb,mBAAmB;EACrB;;EAEA;EACA,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;EACd,iBAAiB;EACjB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,qBAAqB;IACrB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,yDAA6C;IAC7C,4BAA4B;IAC5B,kCAAkC;IAClC,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,aAAa;IACb,yBAAyB;IACzB,mBAAmB;;EAErB;;EAEA;IACE,yBAAyB;IACzB,aAAa;IACb,yCAAyC;IACzC,kBAAkB;IAClB,UAAU;;EAEZ;;EAEA;IACE,iBAAiB;IACjB,qBAAqB;IACrB,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,aAAa;EACf;EACA;IACE,kCAAkC;IAClC,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;IACjB,cAAc;IACd,WAAW;IACX,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,aAAa;IACb,8BAA8B;IAC9B,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,mBAAmB;IACnB,oBAAoB;IACpB,eAAe;IACf,eAAe;EACjB;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;EACA;IACE,sBAAsB;EACxB;EACA,0BAA0B;EAC1B;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,UAAU;EACZ;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;;;AAIA;EACE;IACE,SAAS;IACT,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,aAAa;EACf;;AAEF;;AAEA,yBAAyB;AACzB;IACI,+BAA+B;EACjC;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,mBAAmB;EACrB;AACF;AACA,4BAA4B;AAC5B;QACQ,+BAA+B;QAC/B;YACI,aAAa;YACb,YAAY;UACd;UACA;YACE,iBAAiB;YACjB,oBAAoB;UACtB;UACA;YACE,iBAAiB;YACjB,gBAAgB;YAChB,mBAAmB;UACrB;UACA;YACE,aAAa;YACb;UACF;UACA;YACE,UAAU;YACV,SAAS;UACX;UACA;YACE,eAAe;UACjB;UACA;YACE,iBAAiB;UACnB;UACA;YACE,iBAAiB;UACnB;UACA;YACE,YAAY;UACd;UACA;YACE,UAAU;UACZ;UACA;YACE,WAAW;YACX,WAAW;UACb;UACA;UACA,mBAAmB;UACnB,OAAO;UACP,WAAW;UACX,aAAa;UACb;UACA;YACE,iBAAiB;UACnB;AACV","sourcesContent":["/* Page: About us */\n\n.link {\n    text-decoration: none; \n    color:black; \n    font-size: 12px; \n  }\n  #aboutus {\n    background-color: #e6ffe6;\n    height: auto;\n    margin: 0;\n    padding: 3rem;\n    border-radius: 20px;\n  }\n  \n  #aboutus h1 {\n  text-align: center;\n  margin-bottom: 0.5rem;\n  color: #e8c140;\n  font-size: 2.5rem;\n  }\n  \n  #aboutus p {\n    font-size: 1rem;\n    line-height: 2;\n  }\n  #aboutus span{\n    font-weight: bold;\n  }\n  #aboutus a{\n    text-decoration: none;\n    color: #e3bd40;\n  }\n  \n  #faq {\n    position: relative;\n    background-image: url(\"../images/faq\\ 1.png\");\n    background-repeat: no-repeat;\n    background-position: center center;\n    background-size: cover;\n    height: auto;\n    padding: 4rem;\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n\n  }\n  \n  #faq .content {\n    background-color: #004d00;\n    padding: 1rem;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n    border-radius: 5px;\n    width: 40%;\n\n  }\n  \n  #faq .content h2 {\n    font-size: 1.5rem;\n    margin-bottom: 0.8rem;\n    color: #fff;\n  }\n  \n  #faq .content h3 {\n    font-size: 0.9rem;\n    line-height: 2;\n    color: #fff;\n  }\n  \n  #faq .content p {\n    font-size: 0.8rem;\n    line-height: 1.5;\n    color: #fff;\n  }\n  \n  #faq .contact {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: row;\n    gap: 10px;\n    white-space: nowrap;\n    width: auto;\n    margin-top: 2rem;\n    padding: 10px;\n  }\n  .item {\n    border-bottom: 1px solid #ffffffa2;\n    padding-top: 10px;\n    padding-bottom: 5px;\n  }\n  .item + .item {\n    margin-top: 10px;\n  }\n  #faq .content span {\n    font-size: 0.7rem;\n    line-height: 2;\n    color: #fff;\n    align-content: center;\n  }\n  \n  .faq-question {\n    cursor: pointer;\n    display: flex;\n    justify-content: space-between;\n    font-size: 1.2rem;\n    transition: 0.4s;\n  }\n  .faq-answer {\n    /* display: none; */\n    padding-bottom: 10px;\n    margin-top: 5px;\n    margin-top: 5px;\n  }\n  i {\n    color: #fff;\n  }\n  #ourpartners {\n    text-align: center;\n  }\n  \n  .partners {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    gap: 3rem;\n  }\n  \n  .partners img {\n    width: 150px;\n    height: 100px;\n  }\n  .contact .btn-yellow:hover {\n    background-color: #fff;\n  }\n  /* 태블릿: max-width 1024px */\n  @media (max-width: 1024px) {\n  #aboutus {\n    padding: 2rem;\n  }\n  #faq {\n    padding: 2rem;\n    justify-content: center;\n  }\n\n  #faq .content {\n    width: 70%;\n  }\n  .partners{\n    gap:1.5rem;\n    white-space: normal;\n  }\n}\n\n\n\n@media  (min-width: 800px) and (max-width: 1024px) {\n  .partners{\n    gap: 2rem;\n    white-space: normal;\n  }\n  .partners img{\n    width: 120px;\n    height: 100px;\n  }\n\n}\n\n/* 모바일: max-width 768px */\n@media (max-width: 768px) {\n    /*responsiveness of about page*/\n  #aboutus {\n    padding: 2rem;\n  }\n  #faq {\n    padding: 2rem;\n  }\n  #faq .content {\n    width: 70%;\n  }\n  .partners{\n    gap:1.5rem;\n  }\n  #faq .contact {\n    flex-direction: row;\n  }\n}\n/* 작은 모바일: max-width 480px */\n@media (max-width: 480px) {\n        /*responsiveness of about page*/\n        #aboutus {\n            padding: 2rem;\n            height: auto;\n          }\n          #aboutus h1 {\n            font-size: 1.5rem;\n            padding-bottom: 1rem;\n          }\n          #aboutus p {\n            font-size: 0.9rem;\n            line-height: 1.8;\n            text-align: justify;\n          }\n          #faq {\n            padding: 2rem;\n            margin:1rem\n          }\n          #faq .content {\n            width: 95%;\n            right: 5%;\n          }\n          #faq .content h2{\n            font-size: 1rem;\n          }\n          #faq .content h3{\n            font-size: 0.9rem;\n          }\n          #faq .content p{\n            font-size: 0.8rem;\n          }\n          .item{\n            height: auto;\n          }\n          .partners{\n            gap:0.5rem;\n          }\n          .partners img{\n            width:100px;\n            height:auto;\n          }\n          #faq .contact {\n          flex-direction: row;\n          gap:3px;\n          padding:5px;\n          z-index: 1000;\n          }\n          #faq .contact span{\n            font-size: 0.7rem;\n          }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
